export function load(key) {
    return localStorage.getItem(key)
}

export function store(key, value) {
    localStorage.setItem(key, value)
}

export function remove(key) {
    localStorage.removeItem(key)
}

export function setToken(value) {
    localStorage.setItem('token', value)
}

export function getToken() {
    return localStorage.getItem('token')
}

export function removeToken() {
    localStorage.removeItem('token')
}

export function setConsoleToken(value) {
    localStorage.setItem('consoleToken', value)
}

export function getConsoleToken() {
    return localStorage.getItem('consoleToken')
}

export function removeConsoleToken() {
    localStorage.removeItem('consoleToken')
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/storage.js
// module id = null
// module chunks = 